import React, { useContext, useEffect, useMemo } from "react";
import Select from "react-select";

import { WizardContext } from "../../index";

export default function PerDaysSelection() {
  const { howOftenDays, setHowOftenDays, howOften, setHowOften } =
    useContext(WizardContext);
  const periodOptions = [
    { value: "week", label: "Week" },
    { value: "month", label: "Month" },
  ];

  const dayOptions = useMemo(() => {
    const maxDays = howOften === "week" ? 7 : 31;
    return Array.from({ length: maxDays }, (_, i) => ({
      value: i + 1,
      label: (i + 1).toString(),
    }));
  }, [howOften]);

  useEffect(() => {
    const isValid = dayOptions.some((opt) => opt.value === howOftenDays);
    if (!isValid) {
      setHowOftenDays(1);
    }
  }, [dayOptions, howOftenDays, setHowOftenDays]);

  return (
    <>
      <Select
        isSearchable={false}
        menuPlacement="auto"
        menuPosition="fixed"
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        className="selectBox"
        classNamePrefix="value"
        options={dayOptions}
        value={dayOptions.find((option) => option.value === howOftenDays)}
        onChange={(selected) => setHowOftenDays(selected.value)}
      />
      <span>days per</span>
      <Select
        isSearchable={false}
        menuPlacement="auto"
        menuPosition="fixed"
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        className="selectBox"
        classNamePrefix="value"
        options={periodOptions}
        value={{
          value: howOften,
          label: howOften === "week" ? "Week" : "Month",
        }}
        onChange={(selectedOption) => {
          setHowOften(selectedOption.value);
          if (selectedOption.value === "week" && howOftenDays.value > 7) {
            setHowOftenDays({ value: 1, label: "1" });
          }
        }}
      />
    </>
  );
}
